import React, { FC } from 'react';

// Utils
import { classNames, defaultHandleTournamentClick } from '@sportal365/smp-widget-utils';

// Types
import { ISubscriberInfo } from '../../../../../../../packages/types';
import { INormalizeTournament } from '../../../../types';

interface Props {
  tournament: INormalizeTournament;
  withReversedDisplay?: boolean;
  handleClick: (info: ISubscriberInfo, clickType: string) => void;
}

export const TournamentInfo: FC<Props> = ({ tournament, withReversedDisplay, handleClick }) => {
  const handleTournamentClick = () => defaultHandleTournamentClick(handleClick, tournament.id, tournament.title);

  return (
    <a href={tournament.url} target={tournament.target} className='no-underline' onClick={handleTournamentClick}>
      <div
        className={classNames(
          {
            'flex gap-2 items-center flex-row flex-1': true,
            'flex-row-reverse': withReversedDisplay,
          },
          `tournament-${tournament.id}-info-container`,
        )}
      >
        <img // do not make it as Image because other venue and etc images are set already
          src={tournament.image}
          alt={tournament.title}
          className={classNames({ 'w-7 h-7 rounded-6 hidden sm:block': true }, `tournament-${tournament.id}-image`)}
        />
        <div className='flex flex-col gap-1'>
          <span
            className={classNames(
              { 'text-4 font-bold text-hiContrast whitespace-pre text-ellipsis overflow-hidden max-w-[130px] sm:max-w-none': true },
              `tournament-${tournament.id}-title`,
            )}
          >
            {tournament.title}
          </span>
          <span
            className={classNames(
              { 'text-2 font-normal text-hiContrast text-start': true, 'text-end': withReversedDisplay },
              `tournament-${tournament.id}-subTitle`,
            )}
          >
            {tournament.subTitle}
          </span>
        </div>
      </div>
    </a>
  );
};
